module.exports = __webpack_public_path__ + "static/media/erick-apunta.5692d66a.png";